import React, { useEffect } from 'react';
import styled from 'styled-components';
import { device } from '../../../../constants';
import DynamicSVGIcon from '../../DynamicSVGIcon';
import ToggleOn from '../../../../assets/icons/Toggle on.svg';
import ToggleOff from '../../../../assets/icons/toggle off.svg';

export const Toggle = styled.div`
  height: 50px;
  display: flex;
  align-items: center;
  cursor: pointer;

  & * {
    fill: ${({ theme }) => theme.contrast.primary} !important;
  }
`;

const ToggleType = (props) => {
  const { item, handleToggle, isActive, itemKey, value } = props;
  const isReadOnly = item?.isReadOnly;
  return (
    <div>
      <Toggle onClick={() => {
        if (!isReadOnly) {
          const val = value === 'Yes' || value === true;
          handleToggle(itemKey, !val);
        }
      }}
      >
        <div
          style={{
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            opacity: isReadOnly ? 0.5 : 1
          }}
        >
          <DynamicSVGIcon
            iconUrl={isActive || value === true ? ToggleOn : ToggleOff}
            width='5rem'
          />
          <span style={{ marginLeft: '5px', fontSize: '1.2rem' }}>
            {isActive || value === true ? 'Yes' : 'No'}
          </span>
        </div>
      </Toggle>
    </div>
  );
};

export default ToggleType;
